import { Injectable, inject } from "@angular/core";
import { TrpcService } from "./trpc.service";

@Injectable({ providedIn: "root" })
export class AdminUserService {
	private readonly trpc = inject(TrpcService);

	list() {
		return this.trpc.client.adminUser.list.query();
	}

	get(userId: string) {
		return this.trpc.client.adminUser.get.query({ userId });
	}
}
